import { render } from "./BuzzLatestPostWidget.vue?vue&type=template&id=a1d21890&scoped=true"
import script from "./BuzzLatestPostWidget.vue?vue&type=script&lang=js"
export * from "./BuzzLatestPostWidget.vue?vue&type=script&lang=js"

import "./buzz-latest-post-widget.scss?vue&type=style&index=0&id=a1d21890&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d21890"]])

export default __exports__